<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <BitQLoginPage :service_title="service_title" :showcase_id="showcase_id"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import BitQLoginPage from '@/components/bitq/BitQLoginPage'

export default {
  name: 'BitQTour',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Tour Guidati", link : 'conv-bitq-tour' } ],

        // Nome welfarebit del servizio
        service_title : "Tour Guidati",

        // Identificativo della vetrina ( fornito da BitQ )
        showcase_id : 122
    }
  },
  components: {
    PageTagline,
    BitQLoginPage
  }
}
</script>

<style scoped></style>